// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-data-table table tfoot th {\r\n    position: sticky;\r\n    bottom: 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
